/* ==========================================================================
   SKINRO Mobile Navigation — Panel stack, search, bottom nav
   ========================================================================== */
(function() {
  'use strict';

  var $ = function(s, p) { return (p || document).querySelector(s); };
  var $$ = function(s, p) { return (p || document).querySelectorAll(s); };

  var pMain = $('#sn-pMain');
  var drBc = $('#sn-dr-bc');
  if (!pMain || !drBc) return;

  /* ═══ STACK-BASED PANEL NAVIGATION ═══ */
  var stack = ['sn-pMain'];

  function getPanel(id) { return $('#' + id); }

  function buildBreadcrumb() {
    var html = '';
    if (stack.length <= 1) {
      html = '<li><span class="sn-dr-title">Meny</span></li>';
    } else {
      html = '<li><button class="sn-dr-back" aria-label="Tillbaka"><svg viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"/></svg> Tillbaka</button></li>';
    }
    drBc.innerHTML = html;
    var backBtn = drBc.querySelector('.sn-dr-back');
    if (backBtn) {
      backBtn.addEventListener('click', goBack);
    }
  }

  function syncAriaExpanded() {
    $$('[data-sn-go]').forEach(function(btn) {
      var targetId = btn.dataset.snGo;
      btn.setAttribute('aria-expanded', stack.indexOf(targetId) !== -1 ? 'true' : 'false');
    });
  }

  function slideTo(id) {
    var target = getPanel(id);
    if (!target) return;
    var current = getPanel(stack[stack.length - 1]);
    if (current) current.classList.add('sn-out');
    target.style.zIndex = stack.length + 1;
    target.classList.add('sn-in');
    target.classList.remove('sn-out');
    target.scrollTop = 0;
    stack.push(id);
    buildBreadcrumb();
    syncAriaExpanded();
  }

  function goBack() {
    if (stack.length <= 1) return;
    var leaving = getPanel(stack.pop());
    if (leaving) {
      leaving.classList.remove('sn-in');
      leaving.classList.add('sn-out');
      setTimeout(function() {
        leaving.classList.remove('sn-out');
        leaving.style.zIndex = '';
      }, 400);
    }
    var current = getPanel(stack[stack.length - 1]);
    if (current) current.classList.remove('sn-out');
    buildBreadcrumb();
    syncAriaExpanded();
  }

  function goToDepth(depth) {
    while (stack.length > depth + 1) {
      var leaving = getPanel(stack.pop());
      if (leaving) {
        leaving.classList.remove('sn-in', 'sn-out');
        leaving.style.zIndex = '';
      }
    }
    var current = getPanel(stack[stack.length - 1]);
    if (current) current.classList.remove('sn-out');
    buildBreadcrumb();
    syncAriaExpanded();
  }

  function resetStack() {
    while (stack.length > 1) {
      var p = getPanel(stack.pop());
      if (p) {
        p.classList.remove('sn-in', 'sn-out');
        p.style.zIndex = '';
      }
    }
    if (pMain) pMain.classList.remove('sn-out');
    buildBreadcrumb();
    syncAriaExpanded();
  }

  /* Bind panel navigation buttons */
  $$('[data-sn-go]').forEach(function(b) {
    b.addEventListener('click', function() {
      slideTo(b.dataset.snGo);
    });
  });

  /* Reset panels when drawer closes */
  var mobileMenu = $('[data-drawer="mobile-menu-drawer"]');
  if (mobileMenu) {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'class' && !mobileMenu.classList.contains('show')) {
          setTimeout(resetStack, 380);
        }
      });
    });
    observer.observe(mobileMenu, { attributes: true });
  }

  /* ═══ SEARCH OVERLAY ═══ */
  var sov = $('#sn-sov');
  var sF = $('#sn-sF');

  function openSearch() {
    if (window.SR_NATIVE_SEARCH) return; /* native S&D mode: sr-overlay.liquid's handler owns search opening */
    /* Close the drawer first if open */
    var closeBtn = $('[data-drawer="mobile-menu-drawer"] [data-drawer-close]');
    if (closeBtn && mobileMenu && mobileMenu.classList.contains('show')) {
      closeBtn.click();
    }
    /* Use SR AI overlay if available, otherwise fall back to native */
    if (window.SkinrollerSearch && window.SkinrollerSearch.open) {
      window.SkinrollerSearch.open();
    } else if (sov) {
      sov.classList.add('sn-on');
      document.body.classList.add('overflow-hidden');
      setTimeout(function() { if (sF) sF.focus(); }, 250);
    }
  }

  function closeSearch() {
    if (sov) {
      sov.classList.remove('sn-on');
      document.body.classList.remove('overflow-hidden');
      if (sF) { sF.blur(); sF.value = ''; }
    }
  }

  /* Search triggers */
  var drS = $('#sn-dr-s');
  if (drS) drS.addEventListener('click', openSearch);
  var sC = $('#sn-sC');
  if (sC) sC.addEventListener('click', closeSearch);

  /* Search pills */
  $$('.sn-spl').forEach(function(p) {
    p.addEventListener('click', function() {
      if (sF) { sF.value = p.textContent; sF.focus(); }
    });
  });

  /* Header search button opens our search overlay on mobile.
     In native S&D mode (window.SR_NATIVE_SEARCH) the header icon must reach
     Noor's ListSet handler untouched — no hijack. */
  var hdrSearchBtns = $$('[data-source="search-drawer"]');
  hdrSearchBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      if (window.SR_NATIVE_SEARCH) return;
      if (window.innerWidth < 768) {
        e.preventDefault();
        e.stopPropagation();
        openSearch();
      }
    }, true);
  });

  /* ═══ ESCAPE KEY ═══ */
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    /* Close search overlay first if open */
    if (sov && sov.classList.contains('sn-on')) {
      closeSearch();
      return;
    }
    /* Close drawer if open */
    if (mobileMenu && mobileMenu.classList.contains('show')) {
      var closeBtn = $('[data-drawer-close]', mobileMenu);
      if (closeBtn) closeBtn.click();
    }
  });

  /* ═══ FOCUS TRAP ═══ */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(container, e) {
    var focusable = Array.from(container.querySelectorAll(FOCUSABLE)).filter(function(el) {
      return el.getBoundingClientRect().width > 0;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  if (mobileMenu) {
    mobileMenu.addEventListener('keydown', function(e) {
      if (e.key === 'Tab') trapFocus(mobileMenu, e);
    });
  }

  if (sov) {
    sov.addEventListener('keydown', function(e) {
      if (e.key === 'Tab') trapFocus(sov, e);
    });
  }

  /* ═══ BREAKPOINT FIX ═══ */
  /* Init breadcrumb */
  buildBreadcrumb();

  /* ═══ FOLD-OUT ACCORDIONS (new single-scroll menu) ═══ */
  $$('[data-sn-acc-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var acc = btn.closest('[data-sn-acc]');
      if (!acc) return;
      var open = acc.classList.toggle('sn-acc--open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();
